import { CardHeading } from "@/pages/Dashboard/styled";
import * as Styled from "./styled";
import Button from "@/components/shared-ui/Button";
import TrainingHighlight from "@assets/training-highlight.png";
import TrainingHighlightFull from "@assets/training-highlight-full.png";
import { useMediaQuery } from "@/hooks/useMatchMedia";

const TrainingCard = () => {
  const isDesktop = useMediaQuery("medium");
  return (
    <Styled.TrainingCard gridColumn="1 / -1">
      <CardHeading>Seccl training videos</CardHeading>
      <Styled.CardWrapper>
        <Styled.HighlightCard
          featureBackground={{ full: true, gradient: "light2" }}
          gridColumn="1"
        >
          <div>
            <strong>How to use our professional portal</strong>
            <p>
              Bitesize training videos showing how to carry out key actions
              through our user interface
            </p>
          </div>
          <Button
            label="See UI training videos"
            variant="tertiary"
            internalLink="/ui-training"
          />
        </Styled.HighlightCard>
        <Styled.HighlightCard
          featureBackground={{ full: true, gradient: "light2" }}
          gridColumn={isDesktop ? "2" : "1"}
        >
          <div>
            <strong>How to use our API</strong>
            <p>
              Get to grips with our API docs with our detailed video walkthroughs
            </p>
          </div>
          <Button
            label="See API training videos"
            variant="tertiary"
            internalLink="/api-training"
          />
        </Styled.HighlightCard>
      </Styled.CardWrapper>
      {isDesktop ? (
        <Styled.TrainingHighlightImagePartial
          src={TrainingHighlight}
          alt="Hub highlights - UI Training"
        />
      ) : (
        <Styled.TrainingHighlightImageFull
          src={TrainingHighlightFull}
          alt="Hub highlights - UI Training"
        />
      )}
    </Styled.TrainingCard>
  );
};

export default TrainingCard;
